<template>
<div>
    <div class="freddies-shop-header">
        <h2>{{ $t('GIFT_SHOP_EXTRA_SPECIAL') }}</h2>
    </div>
    <div class="background--paper">
        <div class="freddies-shop">
            <div class="divider-white--top"></div>
            <div class="shop">
                <div class="shop__product-container">
                    <div class='shop__product-block text-center' v-for="(item, key) in products" :key="key">
                        <div  @click="selectProduct(item)">
                            <product-card :item="item" :allowNavigation="false"/>
                        </div>
                        <button class="btn btn--primary select-button text-sm btn--auto-width" @click="addProduct(item, 1)">Add to Order</button>
                    </div>
                </div>
            </div>
            <div class="freddies-shop-summary">
                <h2>{{ $t('GIFT_SHOP_ORDER_SUMMARY') }}</h2>
                <div class="freddies-shop-summary-items">
                    <div class="freddies-shop-summary-item" v-for="(item, key) in additionalProducts" :key="`${key}`">
                        <img :src="item.images.main.thumbnail" />
                        <div class="freddies-shop-summary-item-info">
                            <p><strong>{{item.title}}</strong></p>
                            <p>{{item.quantity}} x {{currency}}{{item.price}}</p>
                            <button class="order-summary__detail text-left mt-1 underline block" @click="removeProduct(item.productId)">Remove</button>
                            <hr class="divider" />
                        </div>
                    </div>
                </div>

                <div class="freddies-shop-summary-total">
                    <div class="order-summary__summary__costs">
                        <p class="order-summary__detail" v-text="$t('SHOP_SUBTOTAL')"></p>
                        <p class="order-summary__detail" v-text="`${currency}${additionalProductsCost}`"></p>
                    </div>
                    <div class="order-summary__summary__costs">
                        <p class="order-summary__detail" v-text="$t('SHOP_DELIVERY')"></p>
                        <p class="order-summary__detail" v-text="$t('SHOP_FREE')"></p>
                    </div>
                    <div class="order-summary__summary__costs">
                        <p v-if="totalDeliveries > 1" class="order-summary__detail" v-text="$t('SHOP_ORDER_SUMMARY_BOXES', { numOfBoxes: totalDeliveries})"></p>
                        <p v-else class="order-summary__detail" v-text="$t('SHOP_ORDER_SUMMARY_BOX',  {numOfBoxes: totalDeliveries})"></p>
                        <p v-if="totalDeliveries" class="order-summary__detail" v-text="`${currency}${multipleDeliveriesPrice}(each)`"></p>
                        <p v-else class="order-summary__detail" v-text="`${currency}${pricePerOneOffDelivery}`"></p>
                    </div>
                    <div class="order-summary__summary__costs">
                        <p class="order-summary__detail__total" v-text="$t('SHOP_TOTAL')"></p>
                        <p class="order-summary__detail__total" v-text="`${currency}${total}`"></p>
                    </div>
                </div>

                <button class="btn btn--primary next-button btn--auto-width" @click="submit" v-html="$t('FREDDIES_ADDONS_NEXT')"></button>
            </div>
            <div class="divider-white--bottom"></div>
        </div>
    </div>
    <product-modal v-if="selectedProduct" :item="selectedProduct" @close="closeModal()" @addProduct="addProduct"/>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SECTION_FREDDIES_SHOP } from '@/constants/Gifting';
import { turnScrollOff, turnScrollOn } from '@/helpers/ScrollHelpers.js';
import ProductCard from '@/components/partials/account/shop/ProductCard';
import ProductModal from '@/components/partials/account/shop/product-details/ProductModal';

export default {
    name: 'FreddiesShop',
    components: {
        ProductCard,
        ProductModal,
    },
    created() {
        const deliveryType = this.deliveryType === 'one-off' ? 'single_gifting' : 'multi_gifting';
        this.$store.dispatch('shop/fetchProducts', { active_in: deliveryType });
        this.selectedProducts = this.additionalProducts;
    },
    computed: {
        ...mapGetters({
            products: 'shop/getProducts',
            currency: 'localisation/getCurrency',
            additionalProducts: 'gifting/getAdditionalProducts',
            additionalProductsCost: 'gifting/getAdditionalProductsTotalCost',
            deliveryType: 'gifting/getDeliveryType',
            totalPrice: 'gifting/getTotalPriceForDeliveries',
            totalDeliveries: 'gifting/getNumberOfDeliveriesForSubscription',
            selectedBoxName: 'gifting/getSelectedBoxName',
            oneOffGiftPrice: 'gifting/getPricePerOneOffDelivery',
            multipleDeliveriesPrice: 'gifting/getPricePerSubscriptionDelivery',
        }),
        total() {
            return Number(this.totalPrice) + Number(this.additionalProductsCost);
        },
        pricePerOneOffDelivery() {
            let price = this.$store.getters['gifting/getPricePerOneOffDelivery'];
            return parseInt(price || 0);
        },
    },
    data() {
        return {
            selectedProduct: null,
            selectedProducts: {},
        };
    },
    methods: {
        submit() {
            this.$store.commit('gifting/setSectionComplete', SECTION_FREDDIES_SHOP);
            this.$router.push({ name: 'account.gifting.delivery-day' });
        },
        closeModal() {
            this.selectedProduct = null;
            turnScrollOn(document);
        },
        selectProduct(item) {
            this.selectedProduct = item;
            turnScrollOff(document);
        },
        addProduct(payload, quantity = null) {
            if (quantity) {
                payload.quantity = 1;
            }
            this.selectedProducts[payload.productId] = payload;
            this.$store.commit('gifting/updateProducts', this.selectedProducts);
            this.$store.commit('gifting/updateProductsTotalCost');
            this.closeModal();
        },
        removeProduct(id) {
            delete this.selectedProducts[id];
            this.$store.commit('gifting/updateProducts', this.selectedProducts);
            this.$store.commit('gifting/updateProductsTotalCost');
        },
    },
    beforeDestroy() {
        this.closeModal();
    },
};
</script>

<style scoped lang="scss">
    .freddies-shop-header {
        text-align: center;
    }
    .freddies-shop {
        display: flex;
        margin: 0 auto;
        width: 70%;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 50px;

        .select-button {
            margin-top: 10px;
            padding: 6px;
        }

        @media (max-width: 1700px) {
            width: 90%;
        }

        @media (max-width: 999px) {
            gap: 0px;
        }

        .divider-white--top {
            top: unset;
        }
        .divider-white--bottom {
            bottom: 0;
        }

        &-summary {
            max-width: 400px;
            margin: 25px auto;
            flex: 1 auto;
            text-align: center;
            padding: 20px;
            border: 1px solid black;
            background-color: white;

            @media (max-width: 999px) {
                max-width: 500px;
            }

            &-item {
                margin-top: 35px;
                display: inline-flex;
                width: 100%;
                gap: 30px;

                img {
                    width: 95px;
                    height: 125px;
                }

                &-info {
                    text-align: left;
                }

                .divider {
                    margin-top: 30px;
                }
            }

            &-total {
                width: 315px;
                margin: 15px auto;
            }

            .next-button {
                margin-top: 20px;
                padding: 10px 15px;
            }
        }

        .shop {
            max-width: 900px;
            margin: 25px auto;
            padding: 25px;
            flex: 1 auto;

            @media (max-width: 1302px) {
                max-width: 500px;
            }
        }
    }
</style>
